<div class="input-date">
  <mat-form-field
    floatLabel="always"
    appearance="outline"
    subscriptSizing="dynamic"
    [hidden]="showMode()"
    (click)="openDatepicker(rangePicker)"
  >
    @if (label()) {
      <mat-label class="input-date__label">
        @if (hint()) {
          <mat-icon
            class="input-date__hint"
            [matTooltip]="hint()"
          >
            info
          </mat-icon>
        }
        <div class="input-date__label-text">
          {{ label() }}
        </div>
        @if (isRequired && !showMode()) {
          <span class="input-required">*</span>
        }
      </mat-label>
    }
    <span class="mat-form-field__value">
      @if (value.start && value.end) {
        {{ value.start | date }} – {{ value.end | date }}
      } @else {
        -
      }
    </span>
    <mat-date-range-input
      class="mat-form-field__input"
      [formGroup]="group()"
      [rangePicker]="rangePicker"
    >
      <input
        matStartDate
        placeholder="Start"
        [formControl]="start"
      />
      <input
        matEndDate
        placeholder="End"
        [formControl]="end"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle
      matIconSuffix
      [for]="rangePicker"
      [disabled]="disabled() || group().disabled"
    />
    <mat-date-range-picker
      #rangePicker
      [disabled]="disabled() || group().disabled"
    />
    @if (group().value && clearable() && group().enabled) {
      <mat-icon
        class="input-date__clear"
        (click)="clear(); $event.stopPropagation()"
      >
        clear
      </mat-icon>
    }
  </mat-form-field>
  <procure-show-field
    [hidden]="!showMode()"
    [label]="label()"
    [hint]="hint()"
  >
    @if (value.start && value.end) {
      {{ value.start | date }} – {{ value.end | date }}
    } @else {
      -
    }
  </procure-show-field>
</div>
